
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {
  private readonly secretKey = 'Aikya_2025_Phong_HTTT_Ma_HOA_Du_Lieu';
  private key: CryptoJS.lib.WordArray;

  constructor() {
    
    this.key = CryptoJS.SHA256(this.secretKey);
  }

  decryptData(encryptedData: string): any {
    try {
      
      const combined = CryptoJS.enc.Base64.parse(encryptedData);
      
      
      const iv = CryptoJS.lib.WordArray.create(combined.words.slice(0, 4)); 
      const encrypted = CryptoJS.lib.WordArray.create(combined.words.slice(4));
      
      
      const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: encrypted } as any,
        this.key,
        {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }
      );
      
      
      const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8);
      
      if (!decryptedStr) {
        throw new Error('Không thể giải mã dữ liệu - kết quả rỗng');
      }
      
      return JSON.parse(decryptedStr);
    } catch (error: any) {
      console.error('Lỗi giải mã:', error);
      throw new Error(`Không thể giải mã dữ liệu: ${error.message}`);
    }
  }

  
  testDecryption(encryptedData: string): boolean {
    try {
      this.decryptData(encryptedData);
      return true;
    } catch {
      return false;
    }
  }
}